/* eslint-disable array-callback-return */
// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
// local
import { Accordion, Transition } from 'semantic-ui-react';
// stylesheets
import './MainMenu.scss';
// images
import logo from 'assets/images/logo-salvus.png';
import logoSmall from 'assets/images/logo-small.jpeg';
//icons
import VisitIcon from 'assets/icons/menu-icons/VisitIcon';
import PadIcon from 'assets/icons/menu-icons/PadIcon';
import UserIcon from 'assets/icons/menu-icons/UserIcon';
import PepIcon from 'assets/icons/menu-icons/PepIcon';
import HealthInsuranceIcon from 'assets/icons/menu-icons/HealthInsuranceIcon';
import BranchIcon from 'assets/icons/menu-icons/BranchIcon';
import TerminologyIcon from 'assets/icons/menu-icons/TerminologyIcon';
import ReportIcon from 'assets/icons/menu-icons/ReportIcon';
import ArrowIcon from 'assets/icons/menu-icons/ArrowIcon';
import DashboardIcon from 'assets/icons/menu-icons/DashboardIcon';

// menu
import { getMenu } from './routes';
// permissions
import { MENU } from 'app/config/mainMenu';
import FixateMenuButton from '../commons/button/FixateMenuButton';

// const
import { COLORS } from 'app/config/colors';

const MenuItemOther = props => {
  const { title, icon } = props;
  return (
    <li className='nav-link'>
      <NavLink to={props.path} exact={props.exact} title={props.title}>
        <div>
          <span>{title}</span>
          {icon && <span>{icon}</span>}
        </div>
      </NavLink>
    </li>
  );
};

MenuItemOther.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  icon: PropTypes.string,
  image: PropTypes.string,
  section: PropTypes.number
};

class MainMenu extends Component {
  state = {
    activeIndex: 0,
    close: true,
    isHovered: false,
    fixed: false,
    activeHover: null
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  menu = getMenu(this.props.account);

  accordionTitle = (activeIndex, menu, icon, title, iconGreen) => {
    return (
      <Accordion.Title
        style={{ height: '60px' }}
        active={activeIndex === menu}
        index={menu}
        onClick={this.handleClick}
        className='menu-title'
        onMouseOver={() => {
          if (this.state.activeHover !== menu) {
            this.setState({ activeHover: menu });
          }
        }}
        onMouseOut={() => {
          if (this.state.activeHover !== null) {
            this.setState({ activeHover: null });
          }
        }}
      >
        {this.state.activeHover === menu || activeIndex === menu ? (
          <div className='wrapper-icon-open'>{iconGreen}</div>
        ) : (
          <div className='wrapper-icon-open'>{icon}</div>
        )}
        <div className='group'>
          <div>{title}</div>
          <div className='dropdown-menu-div'>
            {activeIndex === menu ? (
              <ArrowIcon fill={COLORS.PRIMARY_VARIANT_DARK} />
            ) : (
              <ArrowIcon
                fill={this.state.activeHover === menu ? COLORS.PRIMARY_VARIANT_DARK : undefined}
              />
            )}
          </div>
        </div>
      </Accordion.Title>
    );
  };

  accordionContent = (activeIndex, menu) => {
    return (
      <Accordion.Content active={activeIndex === menu} className={'wrapper-content'}>
        <Transition duration={300} animation={'slide down'} visible={activeIndex === menu}>
          <ul>
            {this.menu.map(item => {
              if (item.section === menu) {
                return <MenuItemOther key={`menu-${item.path}`} {...item} />;
              }
            })}
          </ul>
        </Transition>
      </Accordion.Content>
    );
  };

  menuItem = (activeIndex, menu, icon, title, iconGreen) => {
    return (
      <>
        {this.accordionTitle(activeIndex, menu, icon, title, iconGreen)}
        {this.accordionContent(activeIndex, menu)}
      </>
    );
  };

  isThereContentOnTheMenu = menu => {
    return this.menu.filter(item => item.section === menu).length > 0;
  };

  render() {
    const { activeIndex } = this.state;

    const sizeIconOpen = 20;
    const sizeIconClose = 20;

    const menu = [
      {
        menu: MENU.DASHBOARD,
        title: 'DASHBOARDS',
        icon: <DashboardIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <DashboardIcon
            width={sizeIconClose}
            height={sizeIconClose}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        )
      },
      {
        menu: MENU.VISIT,
        title: 'VISITA',
        icon: <VisitIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <VisitIcon
            width={sizeIconClose}
            height={sizeIconClose}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        )
      },
      {
        menu: MENU.PAD,
        title: 'PAD',
        icon: <PadIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <PadIcon width={sizeIconClose} height={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
        )
      },
      {
        menu: MENU.PEP,
        title: 'PEP',
        icon: <PepIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <PepIcon width={sizeIconClose} height={sizeIconClose} fill={COLORS.ACCENTUATED_VARIANT} />
        )
      },
      {
        menu: MENU.REPORT,
        title: 'RELATÓRIOS',
        icon: <ReportIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <ReportIcon
            width={sizeIconClose}
            height={sizeIconClose}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        )
      },
      {
        menu: MENU.USERS,
        title: 'USUÁRIOS',
        icon: <UserIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <UserIcon
            width={sizeIconClose}
            height={sizeIconClose}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        )
      },
      {
        menu: MENU.ORGANIZATIONAL,
        title: 'ORGANIZACIONAL',
        icon: <BranchIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <BranchIcon
            width={sizeIconClose}
            height={sizeIconClose}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        )
      },

      {
        menu: MENU.REGISTRATION,
        title: 'CADASTROS',
        icon: <HealthInsuranceIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <HealthInsuranceIcon
            width={sizeIconClose}
            height={sizeIconClose}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        )
      },
      {
        menu: MENU.TERMINOLOGY,
        title: 'TERMINOLOGIA',
        icon: <TerminologyIcon width={sizeIconOpen} height={sizeIconOpen} />,
        iconGreen: (
          <TerminologyIcon
            width={sizeIconClose}
            height={sizeIconClose}
            fill={COLORS.ACCENTUATED_VARIANT}
          />
        )
      }
    ];

    return (
      <div id='main-menu' style={this.props.close ? { width: '70px' } : { width: '260px' }}>
        <div className={'wrapper-menu-list'}>
          <div className={`logo-small-div ${this.props.close ? 'close' : 'open'}`}>
            <img
              className={this.props.close ? 'logo-small' : ''}
              src={this.props.close ? logoSmall : logo}
              alt='Salvus'
            />
          </div>
          {this.props.close ? (
            <div className='wrapAccordion'>
              <div className='icons'>
                {menu.map(menuItem => {
                  const { menu, iconGreen, icon } = menuItem;
                  return (
                    this.isThereContentOnTheMenu(menu) && (
                      <div className='icon' key={menu}>
                        {menu === activeIndex ? iconGreen : icon}
                      </div>
                    )
                  );
                })}
              </div>
            </div>
          ) : (
            <div className='wrapperAccordion'>
              <Accordion className='accordion-menu'>
                {menu.map(menuItem => {
                  const { menu, title, icon, iconGreen } = menuItem;

                  return (
                    this.isThereContentOnTheMenu(menu) &&
                    this.menuItem(activeIndex, menu, icon, title, iconGreen)
                  );
                })}
              </Accordion>
            </div>
          )}
        </div>
        <div className='fixateMenuBox'>
          <FixateMenuButton
            menuState={{ close: this.props.close, fixed: this.props.fixed }}
            handleState={this.props.handleState}
          />
        </div>
      </div>
    );
  }
}

MainMenu.propTypes = {
  account: PropTypes.object,
  close: PropTypes.bool,
  onChange: PropTypes.func,
  fixed: PropTypes.bool,
  handleState: PropTypes.func
};

export default MainMenu;
